<div class="backdrop" (click)="retry()"></div>
<div class="error-box">
  <div class="error-header">
    <p>Unexpected Error</p>
       <em class="material-icons" (click)="onClose()">close</em>
  </div>

  <div class="error-box-content">
    <div>
    <p><strong>We are sorry, an unexpected error occurred.</strong></p>
    <br/>
    </div>
    <button class="btn btn-primary" (click)="retry()">Please Try Again</button>
  </div>
</div>

